import { Card, Descriptions } from 'antd';
import {Icon} from '~/components';

function AccountFormInfo({currentUser})
{
	const isCompany = currentUser?.for === 'congty';

	return (
		<>
			{isCompany && <Card style={{ maxWidth: 800, margin: 'auto', marginTop: 32 }} bordered>
				<Descriptions bordered column={1} labelStyle={{ fontWeight: 'bold', width: 200 }}>
					<Descriptions.Item label="Tên công ty">
						{Icon.mail} {currentUser?.companyName}
					</Descriptions.Item>
					<Descriptions.Item label="Mã số thuế">
						{Icon.phone} {currentUser?.taxCode}
					</Descriptions.Item>
					<Descriptions.Item label="Địa chỉ">
						{Icon.environment} {currentUser?.companyAddress}
					</Descriptions.Item>
				</Descriptions>
			</Card>}

			<Card style={{ maxWidth: 800, margin: 'auto', marginTop: 32 }} bordered>
				<Descriptions bordered column={1} labelStyle={{ fontWeight: 'bold', width: 200 }}>
				{isCompany && <Descriptions.Item label="Người đại diện">
					{Icon.user} {currentUser?.name}
				</Descriptions.Item>}

				<Descriptions.Item label="Email">
					{Icon.mail} {currentUser?.email}
				</Descriptions.Item>
				<Descriptions.Item label="Số điện thoại">
					{Icon.phone} {currentUser?.phone}
				</Descriptions.Item>
				<Descriptions.Item label="Địa chỉ">
					{Icon.environment} {currentUser?.address}
				</Descriptions.Item>
				</Descriptions>

			</Card>
		</>

	)
}

export default AccountFormInfo;